// A tiny shared handle to the live MapController so non-map components (e.g. the field panel) can
// read the viewport bbox or trigger a fit without prop-drilling the map instance.
import type { MapController } from './controller';

export const mapRef: { current: MapController | null } = { current: null };
